export default __webpack_public_path__ + "static/media/hero.ee46954c.png";